import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "John's expertise in tax planning saved our company thousands of dollars. His attention to detail and proactive approach make him an invaluable partner for our business.",
      author: "Sarah Thompson",
      position: "CEO, TechStart Solutions"
    },
    {
      quote: "Professional, reliable, and always available when we need guidance. John has been instrumental in helping us navigate complex financial decisions with confidence.",
      author: "Michael Chen",
      position: "Owner, Chen Manufacturing"
    },
    {
      quote: "I've worked with John for over 10 years for both personal and business accounting. His knowledge and dedication to client service are exceptional.",
      author: "Jennifer Rodriguez",
      position: "Small Business Owner"
    }
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Client Testimonials</h2>
          <p className="section-description">What my clients say about working with me</p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card fade-in">
              <div className="testimonial-content">
                <i className="fas fa-quote-left"></i>
                <p>{testimonial.quote}</p>
              </div>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;